/* LP mega menu — click-driven state machine (vanilla JS) */
(function () {
  var SUB_EXIT_MS = 260;

  function init(root) {
    if (!root || root.dataset.lpReady === "1") return;
    root.dataset.lpReady = "1";

    var triggers = Array.prototype.slice.call(root.querySelectorAll("[data-top-trigger]"));
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-lp-panel]"));
    var indicator = root.querySelector(".lp-nav__indicator");
    var list = root.querySelector(".lp-nav__list");

    var activeTop = null;
    var exitTimer = null;

    function panelFor(key) {
      return root.querySelector('[data-lp-panel="' + key + '"]');
    }

    function measure(panel) {
      if (!panel) return;
      var h = panel.scrollHeight;
      if (h > 0) root.style.setProperty("--lp-panel-h", h + "px");
    }

    function moveIndicator(key) {
      if (!indicator || !list) return;
      var el = list.querySelector('[data-top-trigger="' + key + '"]');
      if (!el) return;
      indicator.style.transform = "translateX(" + el.offsetLeft + "px)";
      indicator.style.width = el.offsetWidth + "px";
      indicator.classList.add("lp-nav__indicator--on");
    }

    function setSub(panel, key, animate) {
      var subs = Array.prototype.slice.call(panel.querySelectorAll("[data-lp-sub]"));
      var feats = Array.prototype.slice.call(panel.querySelectorAll("[data-lp-subfeature]"));
      var l2s = Array.prototype.slice.call(panel.querySelectorAll("[data-lp-sub-trigger]"));

      function apply() {
        subs.forEach(function (s) {
          var on = s.getAttribute("data-lp-sub") === key;
          s.classList.toggle("lp-sub--active", on);
          s.classList.toggle("lp-swap--in", on);
          s.classList.remove("lp-swap--out");
          if (on) {
            // herstart de enter-animatie
            void s.offsetWidth;
          }
        });
        feats.forEach(function (f) {
          var on = f.getAttribute("data-lp-subfeature") === key;
          f.classList.toggle("lp-subfeature--active", on);
          f.classList.toggle("lp-swap--in", on);
          f.classList.remove("lp-swap--out");
        });
        l2s.forEach(function (a) {
          a.classList.toggle("lp-panel__l2--active", a.getAttribute("data-lp-sub-trigger") === key);
        });
        panel.dataset.lpActiveSub = key;
        measure(panel);
      }

      if (!animate) {
        apply();
        return;
      }

      var current = panel.querySelector(".lp-sub--active");
      var currentFeat = panel.querySelector(".lp-subfeature--active");
      if (current) {
        current.classList.remove("lp-swap--in");
        current.classList.add("lp-swap--out");
      }
      if (currentFeat) {
        currentFeat.classList.remove("lp-swap--in");
        currentFeat.classList.add("lp-swap--out");
      }
      window.clearTimeout(exitTimer);
      exitTimer = window.setTimeout(apply, SUB_EXIT_MS);
    }

    function closeNow() {
      window.clearTimeout(exitTimer);
      root.classList.remove("lp-header--open");
      panels.forEach(function (p) {
        p.classList.remove("lp-panel--active", "lp-panel--swap");
      });
      triggers.forEach(function (t) {
        t.classList.remove("lp-nav__link--active");
        t.setAttribute("aria-expanded", "false");
      });
      if (indicator) indicator.classList.remove("lp-nav__indicator--on");
      activeTop = null;
    }

    function openTop(key) {
      var panel = panelFor(key);
      if (!panel) return;
      var swapping = activeTop !== null && activeTop !== key;

      panels.forEach(function (p) {
        p.classList.remove("lp-panel--active", "lp-panel--swap");
      });
      triggers.forEach(function (t) {
        var on = t.getAttribute("data-top-trigger") === key;
        t.classList.toggle("lp-nav__link--active", on);
        t.setAttribute("aria-expanded", on ? "true" : "false");
      });

      panel.classList.add("lp-panel--active");
      if (swapping) panel.classList.add("lp-panel--swap");
      root.classList.add("lp-header--open");
      activeTop = key;

      var first = panel.querySelector("[data-lp-sub-trigger]");
      setSub(panel, first ? first.getAttribute("data-lp-sub-trigger") : "", false);
      moveIndicator(key);
    }

    triggers.forEach(function (t) {
      var key = t.getAttribute("data-top-trigger");
      function toggle(e) {
        e.preventDefault();
        if (activeTop === key) closeNow();
        else openTop(key);
      }
      t.addEventListener("click", toggle);
      t.addEventListener("keydown", function (e) {
        // AANPASSING: "Enter" zat hier ook in, maar een <a> vuurt bij Enter
        // eerst keydown en daarna click -> toggle liep twee keer en het paneel
        // klapte meteen weer dicht. Enter wordt nu door de click afgehandeld.
        if (e.key === "ArrowDown" || e.key === " ") toggle(e);
      });
    });

    root.querySelectorAll("[data-lp-sub-trigger]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        var panel = a.closest("[data-lp-panel]");
        var key = a.getAttribute("data-lp-sub-trigger");
        if (!panel || panel.dataset.lpActiveSub === key) return;
        setSub(panel, key, true);
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || !activeTop) return;
      var trigger = root.querySelector('[data-top-trigger="' + activeTop + '"]');
      closeNow();
      if (trigger) trigger.focus();
    });

    document.addEventListener("mousedown", function (e) {
      if (activeTop && !root.contains(e.target)) closeNow();
    });

    window.addEventListener("resize", function () {
      if (activeTop) {
        measure(panelFor(activeTop));
        moveIndicator(activeTop);
      }
    });

    /* Theme editor: een menukolom-blok aanklikken opent het bijbehorende
       paneel en zet die kolom actief, zodat je ziet wat je aanpast. De sleutel
       van een kolom is het block-id. */
    function triggerForBlock(blockId) {
      var l2s = root.querySelectorAll("[data-lp-sub-trigger]");
      for (var i = 0; i < l2s.length; i++) {
        if (l2s[i].getAttribute("data-lp-sub-trigger") === blockId) return l2s[i];
      }
      return null;
    }

    /* Blokken zonder eigen kolom: een "Coming soon"-regel of een
       menu-afbeelding. Die dragen data-lp-block met hun block-id. */
    function panelForBlock(blockId) {
      var el = root.querySelector('[data-lp-block="' + blockId + '"]');
      return el ? el.closest("[data-lp-panel]") : null;
    }

    document.addEventListener("shopify:block:select", function (e) {
      var id = e.detail && e.detail.blockId;
      if (!id) return;

      var trigger = triggerForBlock(id);
      if (!trigger) {
        var ownPanel = panelForBlock(id);
        if (ownPanel) openTop(ownPanel.getAttribute("data-lp-panel"));
        return;
      }

      var panel = trigger.closest("[data-lp-panel]");
      if (!panel) return;

      openTop(panel.getAttribute("data-lp-panel"));
      setSub(panel, id, false);
    });

    document.addEventListener("shopify:block:deselect", function (e) {
      var id = e.detail && e.detail.blockId;
      if (id && (triggerForBlock(id) || panelForBlock(id))) closeNow();
    });

    initAnnounce(root);
  }

  /* AANPASSING: de pijlen in de announcement-bar hadden geen handler en deden
     dus niets. Ze bladeren nu door de berichten die in de sectie zijn ingevuld;
     bij één bericht verbergt de CSS ze. */
  function initAnnounce(root) {
    var bar = root.querySelector("[data-lp-announce]");
    if (!bar) return;

    var messages = Array.prototype.slice.call(bar.querySelectorAll(".lp-header__announce-message"));
    if (messages.length < 2) return;

    var index = 0;

    function show(next) {
      messages[index].classList.remove("lp-header__announce-message--active");
      index = (next + messages.length) % messages.length;
      messages[index].classList.add("lp-header__announce-message--active");
    }

    var prev = bar.querySelector(".lp-header__announce-arrow--prev");
    var next = bar.querySelector(".lp-header__announce-arrow--next");

    if (prev) prev.addEventListener("click", function () { show(index - 1); });
    if (next) next.addEventListener("click", function () { show(index + 1); });
  }

  function boot() {
    document.querySelectorAll("[data-lp-header]").forEach(function (root) { init(root); });
  }

  document.addEventListener("DOMContentLoaded", boot);
  // Shopify theme editor: section opnieuw geladen
  document.addEventListener("shopify:section:load", boot);
  if (document.readyState !== "loading") boot();
})();
